var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBookmarkSelectedCu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bookmark - Default",
    clipPath: "url(#clip0_2107_38240)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 6077",
    d: "M12.0031 14.9974C11.8299 14.9979 11.6595 14.9534 11.5087 14.8683L11.5088 14.8681L8.49676 13.1441L8.49625 13.1438C8.04288 12.8847 7.52971 12.7484 7.0075 12.7484C6.48529 12.7484 5.97213 12.8847 5.51875 13.1438L5.51862 13.1439L2.50362 14.8679L2.50361 14.8679L2.5 14.87C2.34784 14.9578 2.17521 15.004 1.99951 15.004C1.8238 15.0039 1.65122 14.9575 1.49915 14.8695C1.34707 14.7815 1.22086 14.655 1.13323 14.5027C1.04561 14.3504 0.999655 14.1777 1 14.002V14V2C1 1.73478 1.10536 1.48043 1.2929 1.29289C1.48043 1.10536 1.73479 1 2 1H12C12.2652 1 12.5196 1.10536 12.7071 1.29289C12.8946 1.48043 13 1.73478 13 2L13 13.9987C13 13.9989 13 13.9991 13 13.9993C12.9997 14.1741 12.9535 14.3458 12.8661 14.4972C12.7786 14.6488 12.6529 14.7748 12.5014 14.8626C12.35 14.9503 12.1782 14.9968 12.0031 14.9974Z",
    stroke: "#EE5294",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2107_38240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.004,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookmarkSelectedCu);
export default __webpack_public_path__ + "static/media/icon-bookmark-selected-cu.af6386205a3b509f448bc1d8dff5a8f1.svg";
export { ForwardRef as ReactComponent };